//import { createQueryKeys, inferQueryKeys } from '@lukemorales/query-key-factory'

import { createQueryKeys, inferQueryKeys } from '@wiggot/libs/react-query'

export const rulesKeys = createQueryKeys('rulesService', {
  getRules: null
})

export type RulesKeys = inferQueryKeys<typeof rulesKeys>

export const VERSION_API_WIGGOT_LEGACY = 'v2.0.2'
